import React from 'react';
import { UsersIcon } from '@heroicons/react/24/outline';
import { GROUP_TYPE_LABELS } from './constants';

const GroupsList = ({
  filteredGroups,
  selectedGroup,
  onSelectGroup,
  searchTerm,
  onSearchTermChange,
}) => {
  return (
    <div className="lg:col-span-1">
      <div className="card">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-medium text-gray-900">Groups ({filteredGroups.length})</h2>
          <div className="relative w-48">
            <input
              type="text"
              placeholder="Search groups..."
              value={searchTerm}
              onChange={(e) => onSearchTermChange(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-3 py-1 pl-8 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2">
              <svg
                className="h-4 w-4 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
          </div>
        </div>

        {filteredGroups.length === 0 ? (
          <div className="py-8 text-center">
            <UsersIcon className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900">No Training Groups</h3>
            <p className="mt-1 text-sm text-gray-500">
              {searchTerm
                ? 'No groups match your search.'
                : 'You are not a member of any training groups yet.'}
            </p>
          </div>
        ) : (
          <div className="space-y-2">
            {filteredGroups.map((group) => (
              <div
                key={group.id}
                onClick={() => onSelectGroup(group)}
                className={`cursor-pointer rounded-lg border p-4 transition-all ${
                  selectedGroup?.id === group.id
                    ? 'border-blue-500 bg-blue-50'
                    : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                }`}
              >
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="text-sm font-medium text-gray-900">{group.name}</h3>
                  </div>
                  <div className="mt-1 flex items-center gap-2">
                    <span className="text-xs text-gray-500">
                      {GROUP_TYPE_LABELS[group.group_type]}
                    </span>
                  </div>
                  <div className="mt-1 flex items-center gap-3 text-xs text-gray-500">
                    <span>{group.member_count || 0} members</span>
                    <span>{group.equipment_assignments?.length || 0} equipment</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default GroupsList;
